import type { Meta, StoryObj } from '@storybook/react';

import { Speech } from './Speech';

const meta: Meta<typeof Speech> = {
  title: 'parts/Speech',
  component: Speech,
  parameters: {
    layout: 'centered',
    backgrounds: {
      default: 'light',
      values: [
        { name: 'light', value: '#f0f0f0' },
        { name: 'dark', value: '#333333' },
      ],
    },
  },
};

export default meta;

type Story = StoryObj<typeof Speech>;

export const Default: Story = {
  args: {
    children: 'はじめまして！私はアマナ、\nこっちはフシマ！',
    variant: 'solid',
  },
};

export const SingleLine: Story = {
  args: {
    children: 'あなたのお名前はなんて言うの？',
    variant: 'solid',
  },
};
